import httpClient from '../../../global/httpClient';
import * as apis from '../../../constants/api';

export const getBook = (id) => httpClient.get(apis.GET_BOOK + id);
export const generateFile = ({ courseId, bookId, fileId }) =>
  httpClient.get(`${apis.GET_GENERATE_FILE}/${courseId}/${bookId}/${fileId}`);
export const addToFavoriteList = (payload) =>
  httpClient.post(apis.POST_VIDEOS_COLLECT, { ...payload }, { ignore: true });
export const getBeforePractice = (payload) =>
  httpClient.get(`${apis.GET_BEFORE_PRACTICE}/${payload.subjectId}`);
export const getAfterPractice = (payload) =>
  httpClient.get(`${apis.GET_AFTER_PRACTICE}/${payload.subjectId}`);
export const getPractice = (payload) => httpClient.get(`${apis.GET_PRACTICE}/${payload.subjectId}`);
export const getQuestionListType = (payload) => {
  const { type, ..._payload } = payload;
  return httpClient.post(apis.getQuestionListType({ type }), _payload);
};
export const getBeforeChallenge = (payload) =>
  httpClient.get(`${apis.GET_BEFORE_CHALLENGE}/${payload.bookId}`);
export const getAfterChallenge = (payload) =>
  httpClient.get(`${apis.GET_AFTER_CHALLENGE}/${payload.bookId}`);
export const getChallenge = (payload) =>
  httpClient.get(
    `${apis.GET_CHALLENGE}/${payload.bookId}${payload.type !== undefined ? '/' + payload.type : ''}`
  );
export const answer = (payload) =>
  httpClient.post(apis.POST_CHALLENGE_QUESTION_ANSWER, { ...payload }, { ignore: true });
export const tsChallenge = (payload) => httpClient.get(`${apis.TS_CHALLENGE}/${payload.bookId}`);
